<template>
  <div class="table-box">
    <el-table
      ref="myTable"
      v-loading="loading"
      :header-cell-style="{ background:'#F2F3F5',height:'50px',border: '0'}"
      :data="tableData"
      :empty-text="emptyText"
      @select="selectTable"
      @select-all="selectTable_all"
      @selection-change="getSelectData"
      style="width: 100%"
    >
      <el-table-column
        v-if="selection"
        type="selection"
        :selectable="checkSelectable"
        align="center"
        fixed="left"
        width="55">
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableThData"
        :key="index"
        :label="item.label"
        :fixed="item.prop === 'operation' ? 'right' : false"
        :min-width="item.minWidth">
        <template slot-scope="scope" >
          <div v-for="(Sitem, Sindex) in tableThData" :key="Sindex">
            <slot v-if="item.prop === Sitem.prop" :name="Sitem.prop"   :scope="scope" :row="scope.row"></slot>
          </div>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination
      v-if="pagination"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
  export default {
    name: 'Table',
    props: {
      tableThData: {
        type: Array,
        default() {
          return []
        },
      },
      tableTrData: {
        type: Array,
        default() {
          return []
        },
      },
      loading: {
        type: Boolean,
        default() {
          return false
        },
      },
      limit: {
        type: Number,
        default() {
          return 0
        },
      },
      total: {
        type: Number,
        default() {
          return 0
        },
      },
      offset: {
        type: Number,
        default() {
          return 0
        },
      },
      pagination: {
        type: Boolean,
        default() {
          return true
        }
      },
      selection: {
        type: Boolean,
        default() {
          return false
        }
      },
      emptyText:{
        type: String,
        default() {
          return "暂无数据"
        }
      }
    },
    data() {
      return {
        tableData: [],
        currentPage: 0,
        pageSize: 10,
      }
    },
    created () {
      this.tableData = this.tableTrData
      this.currentPage = parseInt(this.offset / this.limit) + 1
      this.pageSize = this.limit
    },
    methods: {
      handleSizeChange (limit) {
        this.$emit('handleCurrentChange', 0)
        this.$emit('handleSizeChange', limit)
      },
      handleCurrentChange (val) {
        let offsetVal = (val - 1) * this.limit
        this.$emit('handleCurrentChange', offsetVal)
      },
      getSelectData (selection) {
        this.$emit('getSelectData', selection)
      },
      selectTable (selection, row) {
        this.$emit('selectTable', selection, row)
      },
      selectTable_all (selection) {
        this.$emit('selectTable_all', selection)
      },
      checkSelectable (row) {
        return this.$parent.checkSelectable_all(row)
      }

    },
    computed: {
    },
    components: {
    },
    mounted () {
      this.$nextTick(() => {
        // myTable是表格的ref属性值
        if (this.$refs.myTable && this.$refs.myTable.doLayout) {
          this.$refs.myTable.doLayout();
        }
      })
    },
    watch: {
      tableTrData: function() {
        this.tableData = this.tableTrData
      },
      limit: function() {
        this.pageSize = this.limit
      },
      offset: function() {
        this.currentPage = parseInt(this.offset / this.limit) + 1
      }
    }
  }
</script>
<style lang="scss" scoped>
.table-box{
  margin-top: 20px;
  ::v-deep {
    .el-table{
      th.el-table__cell {
        .cell{
          color: #333;
          font-size: 14px;
          font-weight: 600;
          color: #333333;
        }
      }
    }
    .btn-prev,.btn-next{
      background: #fff;
      border: 1px solid #ccc;
    }
    .btn-prev:disabled,.btn-next:disabled{
      background: #f4f4f5;
      border: 1px solid #ccc;
    }
    .el-pager{
      li{
        background: #fff;
        border: 1px solid #ccc;
      }
    }
    .el-button--text{
      color: #3775FF;
    }
    .el-button--text.error{
      color: #F74A4A;
    }
  }
}
</style>
